module.exports = __webpack_public_path__ + "img/easy-setup-thumbnail.d09043bb.png";